import yup from 'utils/yup';

import { initialCheckoutValue } from './schema';

export const paymentFormValidationSchema = yup.object({
  number: yup.string().required(),
  card_name: yup.string().required(),
  expiry_month: yup.string().required(),
  expiry_year: yup.string().required(),
  cvc: yup.number().required(),
});

export const transformCheckoutDataToFormdata = (checkoutApiData: any) => {
  const formData: typeof initialCheckoutValue = {
    ...initialCheckoutValue,
    number: checkoutApiData?.number || '',
    card_name: checkoutApiData?.card_name || '',
    expiry_month: checkoutApiData?.expiry_month || '',
    expiry_year: checkoutApiData?.expiry_year || '',
    cvc: checkoutApiData?.cvc || '',
    country: checkoutApiData?.country ? { name: checkoutApiData?.country, iso: checkoutApiData?.country } : '',
    city: checkoutApiData?.city || '',
    state: checkoutApiData?.state || '',
    address_1: checkoutApiData?.address_1 || '',
    address_2: checkoutApiData?.address_2 || '',
    zip_code: checkoutApiData?.zip_code || '',
  };

  return formData;
};
